import httpclient from 'libs/Axios';

const fetchList = async (path: string, params: Record<string, string | number>) => {
  const search = new URLSearchParams(Object.entries(params).map(([key, value]) => [key, String(value)]));
  const response = await httpclient().get(`${path}?${search.toString()}`);
  if (response?.data?.code !== 200) throw new Error(response?.data?.message || 'Unable to load personalised content.');
  return Array.isArray(response?.data?.data) ? response.data.data : [];
};

export const fetchChildcareItems = ({ age, gender }) => fetchList('/comm/parentHelpDesk/aicc/list', {
  age,
  gender: String(gender || '').toLowerCase(),
});

export const fetchInspireItems = ({ age }) => fetchList('/comm/inspire365/random/list', { age });

export const fetchStudentInfoItems = ({ name, age, gender }) => fetchList('/comm/admissions_assured/ai_student_information', {
  student_name: name,
  age,
  gender: String(gender || '').toLowerCase(),
});
